import React, {PureComponent} from 'react';


export default class FreePlanPreview extends PureComponent {
    render() {
        return(
            <div className='no-contacts-container panel-container margin-top-20'>
                <p className='big'>Hey {this.props.name},<br/><br/></p>

                <p className='small'>We have a huge announcement!</p>
                <p className='big'><strong>Emitto is now bigger, better and more reliable.</strong><br/><br/></p>

                <p className='small'>We’re introducing new Emitto Plans.</p>
                <p className='small'>Why is this exciting news? 🤔</p>

                <img className='climb-the-top-image' src="/img/climb_the_top.gif" alt='Free Plan gif'/>

                <p className='small'>We have added</p>
                <p className='big blue-text'><strong>Rollover Monthly Credits</strong></p>
                <p className='small'>included in every plan.<br/><br/></p>

                <p className='small'>This will allow you to get the most out of your experience</p>
                <p className='small'>using Emitto!</p>


                {/*<p>There are no contacts imported, you can add a single contact or import multiple contacts.</p>*/}
                <div className='flex-direction-row justify-content-center'>
                    <button
                        onClick={() => this.props.history.push('/subscription-plans')}
                        className=' btn-action margin-bottom-10 margin-top-20'>
                        Choose Your Plan
                    </button>
                </div>
            </div>
        )
    }
}